import { inject } from "@angular/core";
import { ResolveFn } from "@angular/router";
import { take } from "rxjs";
import { SmartAccountService } from "src/app/services/smart-account.service";

/**
 * Fire-and-forget: starts the smart account lookup without blocking navigation.
 * Consumers read the result from `SmartAccountService`, which publishes nothing until the lookup settles.
 * The lookup itself is bounded by a timeout and never errors (failures settle as `Unknown`).
 */
export const smartAccountResolver: ResolveFn<boolean> = () => {
  inject(SmartAccountService).getSmartAccount().pipe(take(1)).subscribe();

  return true;
};
